var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.9V2.1C19 0.6 18.36 0 16.77 0H12.73C11.14 0 10.5 0.6 10.5 2.1V8.9C10.5 10.4 11.14 11 12.73 11H16.77C18.36 11 19 10.4 19 8.9Z",
    fill: "#007AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.1V17.9C8.5 19.4 7.86 20 6.27 20H2.23C0.64 20 0 19.4 0 17.9V11.1C0 9.6 0.64 9 2.23 9H6.27C7.86 9 8.5 9.6 8.5 11.1Z",
    fill: "#007AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19 17.9V15.1C19 13.6 18.36 13 16.77 13H12.73C11.14 13 10.5 13.6 10.5 15.1V17.9C10.5 19.4 11.14 20 12.73 20H16.77C18.36 20 19 19.4 19 17.9Z",
    fill: "#007AFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.5 4.9V2.1C8.5 0.6 7.86 0 6.27 0H2.23C0.64 0 0 0.6 0 2.1V4.9C0 6.4 0.64 7 2.23 7H6.27C7.86 7 8.5 6.4 8.5 4.9Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.427e458d4a62fa93843b95ce9e848fd8.svg";
export { ForwardRef as ReactComponent };